/**
 * The Google Map controls position constants
 *
 * @see https://developers.google.com/maps/documentation/javascript/controls#ControlPositioning
 */
module.exports = {
  TOP_LEFT: 1,
  TOP: 2,
  TOP_CENTER: 2,
  TOP_RIGHT: 3,
  LEFT_CENTER: 4,
  LEFT: 5,
  LEFT_TOP: 5,
  LEFT_BOTTOM: 6,
  RIGHT: 7,
  RIGHT_TOP: 7,
  RIGHT_CENTER: 8,
  RIGHT_BOTTOM: 9,
  BOTTOM_LEFT: 10,
  BOTTOM: 11,
  BOTTOM_CENTER: 11,
  BOTTOM_RIGHT: 12,
  CENTER: 13
};



// WEBPACK FOOTER //
// ./node_modules/tortilla/src/maps/utils/control-position.js